import { openBlock as o, createElementBlock as r, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(i, e) {
  return o(), r("svg", n, [...e[0] || (e[0] = [
    t("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.757 16.485 15 12.243 10.757 8"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
